// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthTemplateWrapper_wrapper__PAP_b"};